module.exports = __webpack_public_path__ + "img/banner_mobile.d006b110.png";